﻿import { LiveDataSetStation } from "../API/LiveData/LiveDataSet";
import { WarningGroup } from "../Model/WarningGroup";
import { ParameterGroupInfo } from "../ParameterGroupInfoSet";
import { DefaultGroupFormatter } from "./DefaultGroupFormatter";
import { IStationValueObject, WarningThreshold } from "./IStationValueFormatter";

export class AlarmLimitGroupFormatter extends DefaultGroupFormatter {

    constructor(parameterGroup: ParameterGroupInfo, sensorId: string = null, private valueLimit: number) {
        super(parameterGroup, sensorId);
    }
    
    public format(liveDataSetStation: LiveDataSetStation, warningRules?: WarningGroup): IStationValueObject {

        var valueObject = super.format(liveDataSetStation);

        // a bit of work will be duplicated in the call below but it's clean code
        const value = super.getLiveDataSetValue(liveDataSetStation);
        if (value !== null && typeof value.Value == 'number' && this.valueLimit != null && value.Value > this.valueLimit) {
            valueObject.WarningThreshold = WarningThreshold.Level3;
        }

        return valueObject;
    }
}